// api
import getEverythingFromApi from '@drivesally/sally-fw/lib/api/lib/getEverything.lib.api';

// react
import React, {Component} from 'react';

// propTypes
import PropTypes from 'prop-types';

// redux
import {connect} from 'react-redux';

// reducerDeductible actions
import {set as setAct} from '../../redux/actions';

// mileagePackage api
import listMileagePackagesApi from '@drivesally/sally-fn/lib/mileagePackage/api/list.api.mileagePackage';

// components
import {FullScreenLoader} from '@drivesally/sally-ui';

// error
import parseError from '../../../error/parseError';

// lib
import {lib} from '@drivesally/sally-ui';

// alerts
const {alert} = lib;

class MileagePackagesFetchContainer extends Component {
  static propTypes = {
    children: PropTypes.node,
    dispatch: PropTypes.func,
  };

  state = {
    initialized: false,
  };

  componentDidMount() {
    this.init();
  }

  init = async () => {
    const {dispatch} = this.props;
    try {
      const {data: mileagePackages} = await getEverythingFromApi(
        listMileagePackagesApi
      );
      dispatch(setAct({mileagePackages}));
      this.setState({initialized: true});
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      alert.info('Refresh');
    }
  };

  render() {
    const {children} = this.props;
    const {initialized} = this.state;
    return initialized ? children : <FullScreenLoader />;
  }
}

export default connect()(MileagePackagesFetchContainer);
